import { useEffect, useState } from 'react'
import moment from 'moment';
import { IAssessment } from '../properties/assessment';

export const useGetCountDown = (exam?: IAssessment) => {
    const [remainingTime, setRemainingTime] = useState<number>(0);

    // Calculate total remaining time in seconds on mount
    useEffect(() => {
        if (exam) {
            const currentTime = moment();
            const startTime = moment(exam.starttime);
            const endTime = moment(exam.endtime);
            const totalDuration = moment(endTime).diff(startTime, 'seconds');
            const timeElapsed = moment(currentTime).diff(startTime, 'seconds');
            const timeLeft = totalDuration - timeElapsed;

            if (timeLeft > 0) {
                setRemainingTime(timeLeft);
            } else {
                setRemainingTime(0);
            }
        }
        // eslint-disable-next-line 
    }, [exam]);

    useEffect(() => {
        const timer = setInterval(() => {
            setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line 
    }, [exam]);

    function getFormattedTime(seconds: number) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        const formattedHrs = hrs > 0 ? `${hrs}:` : '';
        const formattedMins = `${mins < 10 && hrs > 0 ? '0' : ''}${mins}`;
        const formattedSecs = `${secs < 10 ? '0' : ''}${secs}`;

        return `${formattedHrs}${formattedMins}:${formattedSecs}`;
    }


    return { getFormattedTime, remainingTime }
}
